<template>
  <div class="main-layout">
    <Navbar />
    <main class="content">
      <router-view />
    </main>

    <footer class="app-footer">
      <div class="footer-content">
        <div class="footer-section">
          <p><strong>OSACE App</strong> v1.0.0</p>
          <p>&copy; {{ new Date().getFullYear() }} O.S.A.C.E. Craiova</p>
        </div>
        <div class="footer-section links">
          <a href="https://osace.ro" target="_blank">Site-ul Oficial OSACE</a>
          <a href="https://www.facebook.com/profile.php?id=61565194507781" target="_blank">Facebook</a>
          <a href="https://www.instagram.com/o.s.a.c.e/" target="_blank">Instagram</a>
        </div>
      </div>
    </footer>
    </div>
</template>

<script setup>
import Navbar from './Navbar.vue';
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #F7F7F7; /* Fundal Gri OSACE */
}

.content {
  /* ▼▼▼ MODIFICARE: Adaugă 'flex-grow: 1' ▼▼▼ */
  /* Această linie forțează conținutul să ocupe tot spațiul 
     disponibil, împingând footer-ul în jos. */
  flex-grow: 1; 
  
  width: 90%;
  max-width: 1200px;
  margin: 30px auto;
  padding: 20px;
}

/* ▼▼▼ BLOC NOU: STILURI PENTRU FOOTER ▼▼▼ */
.app-footer {
  width: 100%;
  padding: 20px 0;
  background-color: #0E3035; /* Albastru Închis OSACE */
  color: #aebfc2; /* Un gri-albăstrui deschis */
  border-top: 3px solid #1C748C;
}

.footer-content {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* Pentru ecrane mici */
  gap: 15px;
}

.footer-section {
  text-align: left;
}
.footer-section p {
  margin: 5px 0;
  font-size: 0.9em;
}
.footer-section p strong {
  color: #fff;
}

.footer-section.links {
  text-align: right;
  display: flex;
  flex-direction: column; /* Link-urile unul sub altul */
  gap: 5px;
}
.footer-section a {
  color: #fff;
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;
}
.footer-section a:hover {
  text-decoration: underline;
}

/* Stiluri pentru mobil */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column; /* Stivuim totul pe mobil */
    align-items: center;
    text-align: center;
  }
  .footer-section.links {
    text-align: center;
  }
}
/* ▲▲▲ SFÂRȘIT BLOC NOU ▲▲▲ */
</style>